// Real Unsplash photo URLs - direct image links
// Each image has a fixed dimension request to avoid layout shift

const U = (id, w, h) =>
  `https://images.unsplash.com/${id}?w=${w}&h=${h}&fit=crop&auto=format&q=80`;

export const IMG = {
  // Hero
  hero: U("photo-1600585154340-be6161a56a0c", 800, 600), // modern house

  // About home & whyus
  whyUs: U("photo-1504307651254-35680f356dfd", 700, 500), // construction workers
  aboutStory: U("photo-1581094794329-c8112a89af12", 700, 500), // construction site

  // Service detail images
  laRosu: U("photo-1503387762-592deb58ef4e", 600, 400), // concrete/construction
  laCheie: U("photo-1564013799919-ab600027ffc6", 600, 400), // modern finished house
  ansambluri: U("photo-1545324418-cc1a3fa10c00", 600, 400), // residential complex
  renovari: U("photo-1556909114-f6e7ad7d3136", 600, 400), // interior renovation

  // Project portfolio images (12 cards)
  projects: [
    U("photo-1600585154340-be6161a56a0c", 600, 400), // villa modern
    U("photo-1512917774080-9991f1c4c750", 600, 400), // modern luxury house
    U("photo-1564013434775-f71db0030976", 600, 400), // residential neighborhood
    U("photo-1568605114967-8130f3a36994", 600, 400), // modern villa
    U("photo-1493809842364-78817add7ffb", 600, 400), // interior renovation
    U("photo-1572120360610-d971b9d7767c", 600, 400), // modern home
    U("photo-1613490493576-7fde63acd811", 600, 400), // modern house
    U("photo-1582268611958-ebfd161ef9cf", 600, 400), // modern row of houses
    U("photo-1599809275671-b5942cabc7a2", 600, 400), // attic / mansard
    U("photo-1613977257363-707ba9348227", 600, 400), // villa with pool
    U("photo-1480074568708-e7b720bb3f09", 600, 400), // rural house
    U("photo-1518780664697-55e3ad937233", 600, 400), // modern house
  ],

  // Team avatars
  team: [
    U("photo-1560250097-0b93528c311a", 200, 200), // man professional
    U("photo-1573496359142-b8d87734a5a2", 200, 200), // woman professional
    U("photo-1519085360753-af0119f7cbe7", 200, 200), // man portrait
  ],
};
